import { render, staticRenderFns } from "./afterSaleManage.vue?vue&type=template&id=0e18b9d2&scoped=true"
import script from "./afterSaleManage.vue?vue&type=script&lang=js"
export * from "./afterSaleManage.vue?vue&type=script&lang=js"
import style0 from "./afterSaleManage.vue?vue&type=style&index=0&id=0e18b9d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e18b9d2",
  null
  
)

export default component.exports